import RegistrLogo from './RegistrLogo';
export default RegistrLogo;
